<template>
	<div class="container__menuuser">
		<MenuIconCard>
			<template #icon>
				<div class="container__menuuser__notification">
					<div
						:class="[
							'container__menuuser__notification__alert',
							temNotificacoes ? 'notification-enabled' : 'notification-disabled ',
						]"
					/>
					<i class="fas fa-bell" />
				</div>
			</template>
			<template #card>
				<MenuCardNotifications @mudarNotificacao="setarSeExisteNotificacaoNova" />
			</template>
		</MenuIconCard>

		<MenuIconCard>
			<template #icon>
				<div
					style="
						display: flex;
						flex-direction: row;
						align-items: center;
						flex-wrap: wrap;
						position: relative;
					"
				>
					<img
						style="
							border-radius: 50%;
							cursor: pointer;
							height: 25px;
							width: 30px;
							object-fit: cover;
						"
						:src="fotoUrl"
						alt=""
						class="h-6 w-6"
					/>
					<p
						style="
							font-size: 8px;
							cursor: pointer;
							position: absolute;
							margin: 0;
							width: max-content;
							transform: translate3d(-25%, 170%, 0);
						"
					>
						{{ getUserName() }}
					</p>
				</div>
				<!-- <i class="fas fa-user-circle"></i> -->
			</template>
			<template #card>
				<MenuCardUser />
			</template>
		</MenuIconCard>
	</div>
</template>

<script>
import MenuCardNotifications from '../MenuCardNotifications/MenuCardNotifications'
import MenuCardUser from '../MenuCardUser/MenuCardUser'
import MenuIconCard from '../MenuIconCard/MenuIconCard'

export default {
	components: { MenuIconCard, MenuCardNotifications, MenuCardUser },
	data: () => {
		return {
			temNotificacoes: false,
			temUsername: false,
		}
	},
	computed: {
		fotoUrl() {
			return (
				localStorage.getItem('fotoUrl') ||
				`https://ui-avatars.com/api/?name=${this.emailFormatado}&size=25`
			)
		},
		email() {
			return localStorage.getItem('username')
		},
		emailFormatado() {
			return this.email.split('@')[0]
		},
	},
	methods: {
		/**
		 * Método que troca o valor de (temNotificacoes)
		 */
		setarSeExisteNotificacaoNova(exitemNotificacoes) {
			this.temNotificacoes = exitemNotificacoes
		},

		getUserName() {
			const username = localStorage.getItem('username')
			const welcomeFrase = this.$t('hello') + ',' + username
			if (username == 'null') {
				return this.$t('hello') + ',' + this.$t('visitor')
			}
			return welcomeFrase
		},
	},
}
</script>

<style scoped>
.container__menuuser__notification {
	position: relative;
}

.container__menuuser__notification__alert {
	background-color: rgb(var(--color-default));
	border-radius: 50%;
	position: absolute;
	right: 0;
	top: -0.2rem;
	cursor: pointer;
	transform-origin: center;
	transition: all 0.1s linear;
}

.notification-disabled {
	height: 0px;
	width: 0px;
}

.notification-enabled {
	height: 10px;
	width: 10px;
}

.container__menuuser {
	height: 100%;
	display: flex;
}

.fas {
	font-size: 1.2rem;
	color: rgb(var(--color-primary));
	padding-left: 0.5rem;
	padding-right: 0.5rem;
	cursor: pointer;
}
</style>
